module.exports = __webpack_public_path__ + "img/mastercard.b4e4315f.svg";